import { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styles from './Layout.module.css';

export const Layout = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const publicUrl = process.env.PUBLIC_URL || '';

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.branding}>
          <img src={`${publicUrl}/bowongtec-logo.png`} alt="上海伯望" className={styles.logo} />
          <div className={styles.brand}>{t('sessions:pageTitle')}</div>
        </div>
        <nav className={styles.nav}>
          <NavLink
            to="/tasks"
            className={({ isActive }) => (isActive ? `${styles.navLink} ${styles.navLinkActive}` : styles.navLink)}
          >
            {t('tasks:completedTasks')}
          </NavLink>
        </nav>
      </header>
      <main className={styles.main}>{children}</main>
    </div>
  );
};
